(() => {
  const runtimeKey = '__ogeryMegaMenuHoverStabilityV1';

  if (window[runtimeKey]) return;
  window[runtimeKey] = true;

  const desktopQuery = window.matchMedia('(min-width: 1025px)');

  const addBridgeStyles = () => {
    if (document.getElementById('mega-menu-hover-stability-styles')) return;

    const style = document.createElement('style');
    style.id = 'mega-menu-hover-stability-styles';
    style.textContent = `
      @media (min-width: 1025px) {
        .thb-full-menu > .menu-item-has-megamenu > .thb-full-menu--link {
          position: relative;
        }

        .mega-menu-hover-bridge {
          position: absolute;
          z-index: 3;
          top: calc(100% - 2px);
          right: -18px;
          left: -18px;
          height: 30px;
          background: transparent;
          pointer-events: auto;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const activateItem = (item) => {
    const menu = item.closest('.thb-full-menu');

    if (menu) {
      menu.querySelectorAll(':scope > .menu-item-has-children').forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem.classList.remove('menu-item--active', 'menu-item--hiding');
        }
      });
    }

    item.classList.remove('menu-item--hiding');
    item.classList.add('menu-item--active');

    if (item.classList.contains('menu-item-has-megamenu')) {
      document.body.classList.add('body-megamenu-open');
    }
  };

  const bindMenu = (root) => {
    const items = root.querySelectorAll
      ? root.querySelectorAll('.thb-full-menu > .menu-item-has-megamenu')
      : [];

    items.forEach((item) => {
      if (item.dataset.hoverStabilityBound === 'true') return;

      const trigger = item.querySelector(':scope > .thb-full-menu--link');
      const submenu = item.querySelector(':scope > .sub-menu');

      if (!trigger || !submenu) return;

      item.dataset.hoverStabilityBound = 'true';

      const bridge = document.createElement('span');
      bridge.className = 'mega-menu-hover-bridge';
      bridge.setAttribute('aria-hidden', 'true');
      trigger.appendChild(bridge);

      const recover = () => {
        if (!desktopQuery.matches) return;

        activateItem(item);

        // The original header script closes the menu after 50ms. Re-checking
        // after that timer prevents a stale close from winning when the mouse
        // has already returned to the same navigation link or its bridge.
        window.setTimeout(() => {
          if (desktopQuery.matches && trigger.matches(':hover')) {
            activateItem(item);
          }
        }, 80);
      };

      trigger.addEventListener('mouseenter', recover);
      trigger.addEventListener('mouseover', recover);
      trigger.addEventListener('mousemove', () => {
        if (desktopQuery.matches && !item.classList.contains('menu-item--active')) {
          recover();
        }
      });

      bridge.addEventListener('mouseenter', recover);

      submenu.addEventListener('mouseleave', (event) => {
        const nextTarget = event.relatedTarget;

        if (
          desktopQuery.matches &&
          nextTarget instanceof Node &&
          item.contains(nextTarget)
        ) {
          window.setTimeout(() => {
            if (trigger.matches(':hover')) activateItem(item);
          }, 80);
        }
      });
    });
  };

  const initialize = () => {
    addBridgeStyles();
    bindMenu(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    bindMenu(event.target);
  });
})();
